import React from "react";
import {SelectField} from "./FilterComponentStyles";

const PoolShiftStatusFilter = ({value, onChange}) => {
    const statuses = {
        waiting: "Beklemede",
        active_courier_entered: "Aktif (Giriş Yapıldı)",
        active_courier_not_entered: "Aktif (Giriş Yapılmadı)",
        completed_courier_entered: "Tamamlandı (Giriş Yapıldı)",
        completed_courier_not_entered: "Tamamlandı (Giriş Yapılmadı)",
        cancelled: "İptal Edildi"
    };
    return (
        <React.Fragment>
            <h5>{"Durum"}</h5>
            <SelectField value={value} data-testid="pool_shift_status" onChange={onChange}>
                <SelectField.Option data-testid="status_option" value={"all"}>
                    {"Tümü"}
                </SelectField.Option>
                {Object.keys(statuses).map(status => (
                    <SelectField.Option data-testid="status_option" key={status} value={status}>
                        {statuses[status]}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default PoolShiftStatusFilter;
